export function ContactFormRules(values){
    let errors = {};

    if (values.name === '') {
        errors.name = 'Name is required';
    }
    if (values.email === '') {
        errors.email = 'Email address is required';
    }
    if (values.phone === '') {
        errors.phone = 'Number is required';
    }   
    if (values.subject === '') {
        errors.subject = 'Subject is required';
    }   
    if (values.message === '') {
        errors.message = 'Please select Date';
    }   
    return errors; 
}
